import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null,
      customError: null, // ✅ For programmatic errors
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({ errorInfo });
  }

  // ✅ Method to set custom error programmatically
  setCustomError = (errorData) => {
    this.setState({
      hasError: true,
      customError: errorData,
    });
  };

  // ✅ Reset error state
  resetError = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
      customError: null,
    });
    
    // Reload page or navigate back
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // ✅ Use customError if available (from handleShare, etc.)
      const errorTitle = this.state.customError?.title || 'เกิดข้อผิดพลาด';
      const errorMessage = this.state.customError?.message || 'ขออภัย เกิดข้อผิดพลาดที่ไม่คาดคิด';
      const errorIcon = this.state.customError?.icon || '⚠️';

      // ✅ Special styling for REWARD_A_UNAVAILABLE
      const isRewardUnavailable = errorTitle.includes('กลุ่มที่ถูกสร้างครบแล้ว') || 
                                   errorTitle.includes('รางวัล');

      return (
        <div className="error-view" style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '1rem',
        }}>
          <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
            <div className="text-6xl mb-4">
              {isRewardUnavailable ? '🔒' : errorIcon}
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-3">
              {errorTitle}
            </h2>
            <p className="text-gray-600 mb-6 whitespace-pre-line">
              {errorMessage}
            </p>
            <button
              onClick={this.resetError}
              className="cta text-white px-8 py-3 rounded-xl font-bold transition-all"
              style={{
                backgroundColor: '#59c13a',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              {isRewardUnavailable ? 'ตกลง' : 'โหลดหน้าใหม่'}
            </button>
            
            {/* ✅ Debug info (optional, remove in production) */}
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="mt-4 text-left text-xs text-gray-500">
                <summary className="cursor-pointer">รายละเอียดข้อผิดพลาด</summary>
                <pre className="mt-2 p-2 bg-gray-100 rounded overflow-auto">
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    // ✅ Pass setCustomError to children
    return React.cloneElement(this.props.children, {
      onError: this.setCustomError,
    });
  }
}

export default ErrorBoundary;